export default __webpack_public_path__ + "static/media/d1.c705e5bf.png";